import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Skeleton } from "../../../core/Skeleton";
import { useAppSelector } from "../../../hooks";
import { selectIsDesktopView } from "../../../../store/slices/appState";
import { useStyles } from "./Console.style";

export const Console: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const isDesktop = useAppSelector(selectIsDesktopView);

  const renderCard = (key: string) => (
    <div key={key} className={classes.cardPlaceholder}>
      <Skeleton variant="rect" className={classes.skeletonInner} />
    </div>
  );

  const renderSmallThumb = (key: string) => (
    <div key={key} className={classes.smallThumb}>
      <Skeleton variant="rect" className={classes.skeletonInner} />
    </div>
  );

  const renderFeaturedLandscape = (key: string) => (
    <div key={key} className={classes.featuredLandscape}>
      <Skeleton variant="rect" className={classes.skeletonInner} />
    </div>
  );

  const renderGameCard = (key: string) => (
    <div key={key} className={classes.gameCard}>
      <Skeleton variant="rect" className={classes.skeletonInner} />
    </div>
  );

  if (!isDesktop) {
    return (
      <div className={classes.mobileRoot}>
        <Skeleton variant="text" className={classes.greeting} />

        {/* Activity */}
        <div className={classes.activityRow}>
          <Skeleton variant="rect" className={classes.activityStat} />
          <Skeleton variant="rect" className={classes.activityStat} />
        </div>

        {/* Continue Playing */}
        <div className={classes.section}>
          <Skeleton variant="text" className={classes.sectionTitle} />
          <div className={classes.horizontalRow}>
            {renderSmallThumb("recent-1")}
            {renderSmallThumb("recent-2")}
            {renderSmallThumb("recent-3")}
            {renderSmallThumb("recent-4")}
            {renderSmallThumb("recent-5")}
          </div>
        </div>

        {/* Featured cards */}
        <div className={classes.horizontalRow}>
          {renderFeaturedLandscape("featured-1")}
          {renderFeaturedLandscape("featured-2")}
        </div>

        {/* Essential Pass Games*/}
        <div className={classes.section}>
          <Skeleton variant="text" className={classes.sectionTitle} />
          <div className={classes.horizontalRow}>
            {renderGameCard("essential-1")}
            {renderGameCard("essential-2")}
            {renderGameCard("essential-3")}
          </div>
        </div>

        {/* Install & Play Games*/}
        <div className={classes.section}>
          <Skeleton variant="text" className={classes.sectionTitle} />
          <div className={classes.horizontalRow}>
            {renderGameCard("byog-1")}
            {renderGameCard("byog-2")}
            {renderGameCard("byog-3")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={clsx(classes.column, classes.columnLeft)}>
        {renderCard("status")}
        {renderCard("device")}
        {renderCard("activity")}
      </div>
      <div className={classes.column}>
        {renderCard("byog")}
        {renderCard("play_anywhere")}
      </div>
      <div className={clsx(classes.column, classes.featuredPlaceholder)}>
        <Skeleton variant="rect" className={classes.skeletonInner} />
      </div>
    </div>
  );
};
